// src/app/menu-config.ts
import { MenuItem } from '../../models/menu-item/menu-item.model';

export const MENU_ITEMS: MenuItem[] = [
  {
    nombre: 'Inicio',
    icono: null,
    url: 'home',
    validacion: {
      roles: [
        'Administrador',
        'Director de estrategia de proyectos',
        'Administrador del proyecto',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: null
  },
  {
    nombre: 'Facturas',
    icono: null,
    url: 'facturas',
    validacion: {
      roles: [
        'Administrador',
        'Administrador del proyecto',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: null
  },
  {
    nombre: 'Refacturación',
    icono: null,
    url: 'refacturacion',
    validacion: {
      roles: [
        'Administrador',
        'Administrador del proyecto',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: null
  },
  {
    nombre: 'Deductivas',
    icono: null,
    url: 'deductiva',
    validacion: {
      roles: [
        'Administrador',
        'Administrador del proyecto',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: null
  },
  {
    nombre: 'Penalizaciones',
    icono: null,
    url: 'penalizacion',
    validacion: {
      roles: [
        'Administrador',
        'Administrador del proyecto',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: null
  },
  {
    nombre: 'Reportes',
    icono: null,
    url: undefined,
    validacion: {
      roles: [
        'Administrador',
        'Director de estrategia de proyectos',
        'Supervisor del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: [
      {
        nombre: 'Reporte General',
        icono: 'bi bi-bar-chart-fill',
        url: 'reportes',
        validacion: {
          roles: [
            'Administrador',
            'Director de estrategia de proyectos',
            'Supervisor del proyecto'
          ]
        },
        subMenu: null
      },
      {
        nombre: 'Reporte DSI',
        icono: 'bi bi-bar-chart-fill',
        url: 'reportesdsi',
        validacion: {
          roles: [
            'Administrador',
            'Director de estrategia de proyectos',
            'Supervisor del proyecto'
          ]
        },
        subMenu: null
      }
    ]
  },
  {
    nombre: 'Catálogos',
    icono: null,
    url: undefined,
    validacion: {
      roles: [
        'Administrador',
        'Administrador del proyecto',
        'Coordinador administrativo'
      ]
    },
    subMenu: [
      {
        nombre: 'Áreas de facturación',
        icono: 'bi bi-journal-bookmark-fill',
        url: 'areas',
        validacion: {
          roles: [
            'Administrador',
            'Coordinador administrativo'
          ]
        },
        subMenu: null
      },
      {
        nombre: 'Proyectos',
        icono: 'bi bi-clipboard-check',
        url: 'proyectos',
        validacion: {
          roles: [
            'Administrador',
            'Administrador del proyecto'
          ]
        },
        subMenu: null
      },
      {
        nombre: 'Roles',
        icono: 'bi bi-person-lock',
        url: 'roles',
        validacion: {
          roles: [
            'Administrador'
          ]
        },
        subMenu: null
      },
      {
        nombre: 'Usuarios',
        icono: 'bi bi-people',
        url: 'usuarios',
        validacion: {
          roles: [
            'Administrador'
          ]
        },
        subMenu: null
      },
      {
        nombre: 'Años',
        icono: 'bi bi-calendar',
        url: 'anios',
        validacion: {
          roles: [
            'Administrador'
          ]
        },
        subMenu: null
      }
    ]
  }
];
